import React from 'react'
import { StateProvider } from '../stores/share'
import ShareActions from './Share/ShareActions'
import ShareActionsNext from './Share/ShareActionsNext'

export default function Share(props) {
  const { showMultiShareForm } = props

  const classNames = ["bo-content-section"]

  if (showMultiShareForm) {
    classNames.push("bo-content-section-full")
  }else{
    classNames.push("bo-content-section-lg")
  }

  return (
    <StateProvider {...props}>
      <div className={classNames.join(" ")}>
        {showMultiShareForm ? <ShareActions /> : <ShareActionsNext />}
      </div>
    </StateProvider>
  )
}
